<template>
    <Badge
        v-bind:text="teamName"
        size="md"
        variant="light"
        color="gray"
        class="team-badge"
    >
        <template #leftIcon>
            <TeamLogo
                v-bind:teamId="team.id"
                v-bind:alt="teamName"
            />
        </template>
    </Badge>
</template>

<script setup lang="ts">
    import { type PropType, computed } from 'vue';
    import Badge from '@/components/common/badge/Badge.vue';
    import TeamLogo from '@/components/fantasySelection/TeamLogo.vue';
    import { getTranslatedName } from '@/core/lib/translationHelper';
    import type { ITeam } from '@/interface/IFantasySelection';
    import type { ISelection } from '@/interface/IFantasySelectionMyBets';

    const props = defineProps({
        team: {
            type: Object as PropType<ITeam | ISelection>,
            required: true,
        },
    });

    const teamName = computed(() => getTranslatedName(props.team.name));
</script>

<style lang="scss">
    @import "@/components/fantasySelection/TeamBadge";
</style>
